import DgNotice from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgNotice.install = function (Vue) {
  Vue.component(DgNotice.name, DgNotice)
}
export default DgNotice

export { DgNotice }